"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = exports.tooltipPlacementOptions = void 0;
const react_1 = __importStar(require("react"));
const react_dom_1 = require("react-dom");
const Theme_1 = require("../../Theme/Theme");
const useHover_1 = __importDefault(require("./useHover"));
exports.tooltipPlacementOptions = ['top', 'bottom', 'right', 'left'];
const TooltipContainer = Theme_1.styled.div `
  cursor: pointer;
`;
const TooltipText = Theme_1.styled.span `
  cursor: default;
  background-color: ${(props) => props.theme.uiBlack};
  border-radius: 3px;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.24);
  color: ${(props) => props.theme.white};
  font-family: ${(props) => props.theme.font.family.proximaNova};
  font-size: 12px;
  line-height: 14px;
  padding: 6px;
  position: absolute;
  max-width: 360px;
  z-index: 999;
  width: max-content;
  text-transform: none;
  display: 'inline-block';
  transition: opacity 0.3s ease;
`;
const Tooltip = (props) => {
    var _a, _b, _c, _d, _e, _f;
    const targetRef = (0, react_1.useRef)(null);
    const tooltipRef = (0, react_1.useRef)(null);
    const currentTarget = targetRef === null || targetRef === void 0 ? void 0 : targetRef.current;
    const currentTooltip = tooltipRef === null || tooltipRef === void 0 ? void 0 : tooltipRef.current;
    const isTargetHovered = (0, useHover_1.default)(targetRef);
    const isTooltipHovered = (0, useHover_1.default)(tooltipRef);
    const [isHovered, setIsHovered] = (0, react_1.useState)(false);
    const tooltipMargin = 6;
    const body = document.body;
    const docEl = document.documentElement;
    // Top/Left for relevant elements
    const [tooltipTop, setTooltipTop] = (0, react_1.useState)(0);
    const [tooltipLeft, setTooltipLeft] = (0, react_1.useState)(0);
    const targetOffsets = currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.getBoundingClientRect();
    const targetTop = (_a = targetOffsets === null || targetOffsets === void 0 ? void 0 : targetOffsets.top) !== null && _a !== void 0 ? _a : 0;
    const targetLeft = (_b = targetOffsets === null || targetOffsets === void 0 ? void 0 : targetOffsets.left) !== null && _b !== void 0 ? _b : 0;
    const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
    // Height/Width for relevant elements
    const clientHeight = docEl.clientHeight || body.clientHeight || 0;
    const clientWidth = docEl.clientWidth || body.clientWidth || 0;
    const tooltipHeight = (_c = currentTooltip === null || currentTooltip === void 0 ? void 0 : currentTooltip.clientHeight) !== null && _c !== void 0 ? _c : 0;
    const tooltipWidth = (_d = currentTooltip === null || currentTooltip === void 0 ? void 0 : currentTooltip.clientWidth) !== null && _d !== void 0 ? _d : 0;
    const targetHeight = (_e = currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.clientHeight) !== null && _e !== void 0 ? _e : 0;
    const targetWidth = (_f = currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.clientWidth) !== null && _f !== void 0 ? _f : 0;
    const centerHorizontally = (positionLeft) => positionLeft - tooltipWidth / 2 + targetWidth / 2;
    const centerVertically = (positionTop) => positionTop - tooltipHeight / 2 + targetHeight / 2;
    const isLessThanPageHeight = (positionTop) => positionTop < scrollTop ? true : false;
    const isGreaterThanPageHeight = (positionTop) => positionTop + tooltipHeight > clientHeight + scrollTop;
    const isLessThanPageWidth = (positionLeft) => positionLeft < scrollLeft ? true : false;
    const isGreaterThanPageWidth = (positionLeft) => positionLeft + tooltipWidth > clientWidth + scrollLeft;
    const setInBoundsHorizontally = (positionLeft) => isLessThanPageWidth(positionLeft)
        ? tooltipMargin + scrollLeft
        : isGreaterThanPageWidth(positionLeft)
            ? clientWidth + scrollLeft - tooltipWidth - tooltipMargin
            : positionLeft;
    const setInBoundsVertically = (positionTop) => isLessThanPageHeight(positionTop)
        ? tooltipMargin + scrollTop
        : isGreaterThanPageHeight(positionTop)
            ? clientHeight + scrollTop - tooltipHeight - tooltipMargin
            : positionTop;
    const positionTooltip = () => {
        let top = targetTop + scrollTop;
        let left = targetLeft + scrollLeft;
        switch (props.placement) {
            case 'top':
                top -= tooltipHeight;
                top -= tooltipMargin;
                left = centerHorizontally(left);
                break;
            case 'bottom':
                top += targetHeight;
                top += tooltipMargin;
                left = centerHorizontally(left);
                break;
            case 'right':
                left += targetWidth;
                left += tooltipMargin;
                top = centerVertically(top);
                break;
            case 'left':
                left -= tooltipWidth;
                left -= tooltipMargin;
                top = centerVertically(top);
                break;
        }
        top = setInBoundsVertically(top);
        left = setInBoundsHorizontally(left);
        setTooltipTop(top);
        setTooltipLeft(left);
    };
    (0, react_1.useEffect)(() => {
        positionTooltip();
        setIsHovered(isTargetHovered || isTooltipHovered);
    }, [
        isTargetHovered,
        isTooltipHovered,
        targetTop,
        targetLeft,
        scrollTop,
        scrollLeft,
        clientHeight,
        clientWidth,
        targetHeight,
        targetWidth,
    ]);
    const tooltipEl = (react_1.default.createElement(TooltipText, { ref: tooltipRef, style: Object.assign(Object.assign({}, props.style), { opacity: isHovered ? 1 : 0, visibility: isHovered ? 'visible' : 'hidden', top: tooltipTop, left: tooltipLeft }) }, props.title));
    return (react_1.default.createElement(TooltipContainer, { ref: targetRef },
        props.children,
        (0, react_dom_1.createPortal)(tooltipEl, body)));
};
exports.Tooltip = Tooltip;
exports.Tooltip.defaultProps = {
    placement: 'bottom',
};
//# sourceMappingURL=Tooltip.js.map